// GO Insights Domain Configuration
export const goinsightsConfig = {
  // Basic domain information
  id: 'go-insights',
  name: 'GO Insights',
  tagline: 'Fleet Analytics & Insights',
  description: 'Advanced analytics and insights for fleet management.',
  
  // Assets
  logo: '/assets/logos/go-insights-logo',
  whiteLogo: '/assets/logos/go-insights-white-logo',
  favicon: '/assets/favicons/go-insights-favicon.png',
  icon: '/assets/icons/go-insights',
  
  // Navigation
  pages: ['home', 'solutions', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy Now'
  },
                
  // Shop link
  shopLink: 'https://shop.fleethoster.com',

  // UI Configuration
  variant: 'clean',
  showFeatures: true,
  showTestimonials: true,
  
  // Content sections
  hero: {
    title: 'GO Insights',
    subtitle: 'Advanced analytics and insights for fleet management',
    features: ['Advanced Analytics', 'Real-time Insights', 'Predictive Intelligence']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'GO Insights Analytics Solutions',
    subtitle: 'Discover our advanced fleet analytics and insights platform',
    description: 'See how GO Insights transforms fleet data into actionable intelligence'
  },

  features: {
    title: 'GO Insights Features',
    subtitle: 'Advanced Fleet Analytics',
    description: 'Comprehensive analytics and insights platform for fleet management and optimization.',
    items: [
      {
        title: 'Advanced Analytics',
        description: 'Deep analytics with machine learning algorithms for fleet optimization and insights.',
        icon: '📊'
      },
      {
        title: 'Real-time Insights',
        description: 'Real-time insights and alerts for immediate action and decision making.',
        icon: '⚡'
      },
      {
        title: 'Predictive Intelligence',
        description: 'Predictive analytics for maintenance, fuel efficiency, and driver behavior.',
        icon: '🔮'
      },
      {
        title: 'Custom Dashboards',
        description: 'Customizable dashboards and reports tailored to your fleet needs.',
        icon: '📈'
      }
    ]
  },
  
  solutions: {
    title: 'GO Insights Solutions',
    subtitle: 'Advanced analytics and insights for fleet management',
    description: 'Transform your fleet data into actionable insights with our advanced analytics platform.',
    sections: [
      {
        title: 'Take Control Of How Your Assets Are Connected',
        description: 'Explore a diverse range of options that offer enhanced versatility in integrating your vehicle, equipment, and reefer data into the top-rated telematics platform.'
      },
      {
        title: 'Deliver A Seamless Experience Across Mixed Fleets',
        description: "Efface data silos and streamline information management with a seamless experience encompassing all vehicles and equipment."
      },
      {
        title: 'Extract Deeper Insights From Raw Telematics Data',
        description: 'Drive your operations with a purpose-built platform designed to gather, consolidate, and analyze data, unveiling valuable insights for enhancing diverse workflows across the organization.'
      }
    ]
  },
  
  
  testimonials: [
    {
      content: "I don't know how we'd do it without Geotab – the solution is literally in every aspect of our operations.",
      author: "Jonathan Hamilton",
      role: "Director of Fleet Safety and Compliance",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/25.jpg"
    },
    {
      content: "We're excited about what's coming next. It just keeps getting better and better, working with their technology and continuing to evolve. It's been great.",
      author: "Christian Reisch",
      role: "Co-owner",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/20.jpg"
    }
  ],

  blog: {
    title: 'GO Insights Blog',
    subtitle: 'Latest News and Insights',
    description: 'Stay informed with the latest news and insights in fleet management and industry best practices.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'GO Insights | Advanced Fleet Analytics & Business Intelligence',
    description: 'Transform data into insights with comprehensive fleet analytics, business intelligence, and predictive analytics solutions.',
    keywords: [
      'GO insights', 'fleet analytics', 'fleet insights', 'data intelligence', 'fleet optimization', 'predictive analytics',
      'fleet business intelligence', 'fleet data analytics', 'fleet performance analytics', 'fleet intelligence solutions', 'fleet data insights',
      'fleet analytics platform', 'fleet optimization insights', 'fleet performance intelligence', 'fleet data intelligence',
      'fleet analytics solutions', 'fleet business insights', 'fleet performance analytics', 'fleet intelligence platform'
    ],
    
    // Open Graph & Social Media
    ogTitle: 'GO Insights - Advanced Fleet Analytics & Insights',
    ogDescription: 'Advanced analytics and insights for fleet management. Transform data into actionable insights.',
    ogType: 'website',
    ogUrl: 'https://goinsights.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'GO Insights - Advanced Fleet Analytics & Insights',
    twitterDescription: 'Advanced analytics and insights for fleet management. Transform data into actionable insights.',
    
    // Robots
    robots: 'index, follow',
    author: 'GO Insights',
    publisher: 'GO Insights',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'GO Insights | Advanced Fleet Analytics & Business Intelligence',
        description: 'Advanced analytics and insights for fleet management. Transform data into actionable insights with comprehensive fleet analytics.',
        keywords: ['GO insights', 'fleet analytics', 'fleet insights', 'data intelligence', 'fleet optimization']
      },
      solutions: {
        title: 'GO Insights Solutions - Professional Fleet Analytics Services',
        description: 'Comprehensive fleet analytics solutions and business intelligence services. Professional data analysis and fleet optimization.',
        keywords: ['fleet analytics solutions', 'business intelligence services', 'data analysis', 'fleet optimization']
      },
      products: {
        title: 'GO Insights Products - Fleet Analytics Software & Tools',
        description: 'Professional fleet analytics software and business intelligence tools. Advanced analytics platforms and data intelligence solutions.',
        keywords: ['fleet analytics software', 'business intelligence tools', 'analytics platforms', 'data intelligence solutions']
      },
      blog: {
        title: 'GO Insights News & Insights - Fleet Analytics Blog',
        description: 'Latest news, insights, and best practices for fleet analytics and business intelligence. Professional tips and analytics updates.',
        keywords: ['fleet analytics news', 'business intelligence insights', 'analytics best practices', 'fleet optimization tips']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
